<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.Currencies.AssignTitle" | i18nextEager }}: {{ currency().isoCurrencyCode }}
  </ng-template>
  <ng-template #content>
    <div class="flex flex-col gap-md">
      @for (country of countries(); track country.id) {
        <doka-checkbox
          [checked]="isSelected(country.id)"
          [disabled]="!canEdit(country) || isMainCurrency(country)"
          (checkedChange)="toggleCountry(country, $event)"
          [label]="countryLabel(country)"
        />
      }
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
      <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">
        {{ "Common.Cancel" | i18nextEager }}
      </doka-button>
      <doka-button [disabled]="isLoading()" (click)="submit()" color="primary">
        {{ "Common.Save" | i18nextEager }}
      </doka-button>
    </div>
  </ng-template>
</doka-modal-wrapper>
